export enum ZIndex {
    LensPreviewNotification = 1000,
    ApiStepperFooter = 999,
}
